module Meevo.Plugins.Client {
    "use strict";


    export class BookingPreferencesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ClientBookingPreferences> {
        public hasAnyEmployeeOverride: boolean[] = [];
        private serviceDefinition: any[] = [];

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected $translate: angular.translate.ITranslateService) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun);
        }

        public sectionModelRetrieved(): void {
            this.model.services.forEach(s => s['isExpanded'] = false);
            this.hasAnyEmployeeOverride = [];
            this.serviceDefinition = [];
        }

        public onEmployeeOverrides = (employee: any, criteria): any => {

            if (employee.id) {
                let request: Model.EmployeeStepOverides = {
                    serviceGlobalId: criteria.serviceIdList[0],
                    employeeGlobalId: employee.id,
                    steps: null
                }

                let uri = `/api/employee/serviceStepOverrides`;
                this.dataService.customMethodData(uri, 'Post', request).then((res: any) => {
                    employee.steps = _.each(res.data.steps, s => s['employeeId'] = request.employeeGlobalId)
                    _.forEach(employee.steps, (s: any) => s.isMinutesOverriden = true);

                    employee.employeeGlobalId = request.employeeGlobalId;
                    employee.serviceGlobalId = request.serviceGlobalId;
                    let srvIndex = this.model.services.findIndex(srv => srv.id === criteria.serviceIdList[0])
                    this.model.services[srvIndex]['employeeStepOverides'].push(employee);
                });
            }
            else {
                let addEmpFn = (svc: any) => {
                    this.serviceDefinition[criteria.serviceIdList[0]] = svc;
                    employee.steps = [];
                    _.each(svc.serviceSteps, (s: any) => {
                        employee.steps.push({
                            "serviceGlobalId": s.serviceGlobalId,
                            "stepId": s.id,
                            "stepType": s.stepType,
                            "stepTypeDisplay": s.stepTypeDisplay,
                            "minutes": s.minutes,
                            "minutesRevertTo": s.minutes,
                            "stepNumber": s.stepNumber,
                            "overridableFields": "Minutes",
                            "isMinutesOverriden": false,
                            "employeeId": null
                        });
                    });
                    _.forEach(employee.steps, (s: any) => s.isMinutesOverriden = true);

                    employee.employeeGlobalId = null;
                    employee.displayName = this.$translate.instant('LABEL_ANY_EMPLOYEE');
                    employee.serviceGlobalId = criteria.serviceIdList[0];
                    let srvIndex = this.model.services.findIndex(srv => srv.id === criteria.serviceIdList[0])
                    this.model.services[srvIndex]['employeeStepOverides'].unshift(employee);
                    this.hasAnyEmployeeOverride[criteria.serviceIdList[0]] = true;
                }

                if (this.serviceDefinition[criteria.serviceIdList[0]]) {
                    addEmpFn(this.serviceDefinition[criteria.serviceIdList[0]]);
                }
                else {
                    this.dataService.getItem("service", new Guid(criteria.serviceIdList[0].toString())).then(addEmpFn);
                }
            }
        }
        /*  Removes Existing Employees In Service.EmployeeStepOverides  */
        public onEmployeeSelected = (res: any[], req: any) => {

            let srvIndex = this.model.services.findIndex(srv => srv.id === req.criteria.serviceGlobalId);
            _.forEach(this.model.services[srvIndex]['employeeStepOverides'], ovr => {
                let resIndex = res.findIndex(r => ovr.employeeGlobalId === r.id);
                if (resIndex != -1)
                    res.splice(resIndex, 1);
            })

        }

        public onServiceOverrides = (service: any, criteria): any => {

            if (!_.has(service, 'employeeStepOverides')) {
                service['employeeStepOverides'] = [];
            }
            service['isExpanded'] = false;
            this.model.services.push(service);
        }

        public loadEmployeeServiceOverrides = (service: any): any => {

            if (!service.enableIntelliBooking || service.isExpanded || this.mode != Meevo.Model.MaintenanceFormState.Editing) {
                return;
            }

            let uri = `/api/Client/ServiceStepOverrides`;
            let request: Model.ClientEmployeeServiceStepOverrides = {
                clientId: this.parentItemId.toString(),
                ServiceGlobalId: service.id
            }

            this.dataService.customMethodData(uri, 'Post', request).then((res: any) => {
                let overrides = res.data;
                overrides.forEach((srv: Model.ClientServiceStepOverrides) => {
                    srv.steps.forEach((step: Model.ServiceStepOverride) =>
                        step.stepTypeDisplay = step.stepTypeDisplay || Model.ServiceStepTypeEnum[step.stepType])

                    if (!srv.employeeGlobalId) {
                        this.hasAnyEmployeeOverride[service.id] = true;
                        srv.employeeGlobalId = null;
                        srv.displayName = this.$translate.instant('LABEL_ANY_EMPLOYEE');
                    }
                });
                let index = this.model.services.findIndex(srv => srv.id === service.id);
                this.model.services[index]['isExpanded'] = true;
                this.model.services[index]['employeeStepOverides'] = overrides;
            });

        }

        public onClickRevertTo = (step) => {

            let srvIndex = this.model.services.findIndex(srv => srv.id === step.serviceGlobalId);
            let empIndex = this.model.services[srvIndex].employeeStepOverides.findIndex(emp => emp.employeeGlobalId === step.employeeId);
            let stpIndex = this.model.services[srvIndex].employeeStepOverides[empIndex].steps.findIndex(stp => stp.stepId === step.stepId);
            this.model.services[srvIndex].employeeStepOverides[empIndex].steps[stpIndex].minutes = step.minutesRevertTo;

        }

        public onClickDelete = (overrides) => {

            let srvIndex = this.model.services.findIndex(srv => srv.id === overrides.serviceGlobalId);
            let empIndex = this.model.services[srvIndex].employeeStepOverides.findIndex(emp => emp.employeeGlobalId === overrides.employeeGlobalId);
            let stpIndex = this.model.services[srvIndex].employeeStepOverides[empIndex].steps.findIndex(stp => stp.stepId === overrides.stepId);
            _.forEach(this.model.services[srvIndex].employeeStepOverides[empIndex].steps, (s) => s.isMinutesOverriden = false)

            if (overrides.employeeGlobalId == null) {
                this.hasAnyEmployeeOverride[overrides.serviceGlobalId] = false;
            }
        }

        public addAnyEmployeeOverride(serviceId) {
            this.onEmployeeOverrides({ id: null }, { serviceGlobalId: serviceId, showEmployeesOnly: true, serviceIdList: [serviceId], enableIntelliBooking: true });
        }
    }
}

